import {
  IDisbursementsApi,
  CommissionAgreementPayload,
  GetAgreementParams,
  GetTenantSettlementsParams,
  GetTenantPendingSettlementsParams,
  DisbursementConfigPayload,
  CreateDisbursementConfigPayload,
} from '../types';
import { instance } from './instance';

export const disbursementsApi: IDisbursementsApi = {
  getTenantPayouts: async (params) => {
    let queryString = '';
    if (params?.status) queryString += `?status=${params.status}`;
    if (params?.beneficiary)
      queryString += `${queryString ? '&' : '?'}beneficiary=${
        params.beneficiary
      }`;
    if (params?.outletId)
      queryString += `${queryString ? '&' : '?'}outletId=${params.outletId}`;
    if (params?.page)
      queryString += `${queryString ? '&' : '?'}page=${params.page}`;
    if (params?.perPage)
      queryString += `${queryString ? '&' : '?'}perPage=${params.perPage}`;
    return await instance.get(`/disbursements/tenants/payouts${queryString}`);
  },
  getTenantSettlements: async (params: GetTenantSettlementsParams) => {
    let queryString = `?payoutId=${params.payoutId}`;
    if (params.orderSlug) {
      queryString += `&orderSlug=${params.orderSlug}`;
    }
    return await instance.get(
      `/disbursements/tenants/settlements${queryString}`
    );
  },
  getTenantPendingSettlements: async (
    params?: GetTenantPendingSettlementsParams
  ) => {
    let queryString = '';
    if (params?.orderSlug) {
      queryString += `${queryString ? '&' : '?'}orderSlug=${params.orderSlug}`;
    }
    if (params?.from) {
      queryString += `${queryString ? '&' : '?'}from=${params.from}`;
    }
    if (params?.to) {
      queryString += `${queryString ? '&' : '?'}to=${params.to}`;
    }
    return await instance.get(
      `/disbursements/tenants/settlements/pending${queryString}`
    );
  },
  getTenantPayoutsSummary: async () =>
    await instance.get('/disbursements/tenants/payouts/summary'),
};
export const createCommissionAgreement = async (
  payload: CommissionAgreementPayload
) => {
  const { data } = await instance.post('/commission-agreements', payload);
  return data?.data ?? data;
};

export const createDefaultCommissionAgreement = async (
  tenantId: string,
  vendorId: number | string
) => {
  const { data } = await instance.post(
    `/commission-agreements/defaults/vendor/${tenantId}/${vendorId}`
  );
  return data?.data ?? data;
};

export const listCommissionAgreements = async (params?: GetAgreementParams) => {
  const { data } = await instance.get('/commission-agreements', { params });
  return data?.data ?? data;
};

export const updateCommissionAgreement = async (
  agreementId: string | number,
  payload: {
    isActive: boolean;
    effectiveFrom: string;
    effectiveTo: string | null;
  }
) => {
  const { data } = await instance.put(
    `/commission-agreements/${agreementId}`,
    payload
  );
  return data?.data ?? data;
};

export const createDefaultDisbursementConfig = async (
  tenantId: string,
  outletId: string | number
) => {
  const { data } = await instance.post(
    `/disbursement-config/defaults/vendor/${tenantId}/${outletId}`
  );
  return data?.data ?? data;
};

export const listDisbursementConfigs = async (params?: {
  tenantId?: string;
  outletId?: string | number;
  entityType?: 'VENDOR' | 'TENANT';
}) => {
  const { data } = await instance.get('/disbursement-config', { params });
  return data?.data ?? data;
};

export const updateDisbursementConfig = async (
  configId: string | number,
  payload: DisbursementConfigPayload
) => {
  const { data } = await instance.put(
    `/disbursement-config/${configId}`,
    payload
  );
  return data?.data ?? data;
};

export const bulkSetDisbursementDefaults = async (
  tenantId: string,
  payload: DisbursementConfigPayload
) => {
  const { data } = await instance.post(
    `/disbursement-config/defaults/vendor/${tenantId}/bulk`,
    payload
  );
  return data?.data ?? data;
};

export const getTenantDefaultDisbursementConfig = async (
  tenantId: string
) => {
  const { data } = await instance.get(
    `/disbursement-config/defaults/vendor/${tenantId}`
  );
  return data?.data ?? data;
};

export const setTenantDefaultDisbursementConfig = async (
  tenantId: string,
  payload: DisbursementConfigPayload
) => {
  const { data } = await instance.post(
    `/disbursement-config/defaults/vendor/${tenantId}`,
    payload
  );
  return data?.data ?? data;
};

export const createDisbursementConfig = async (
  payload: CreateDisbursementConfigPayload
) => {
  const { data } = await instance.post('/disbursement-config', payload);
  return data?.data ?? data;
};
